import React, { Component } from 'react';
import toast from 'react-hot-toast';
import './OrderAdditionalInfoV1.scss';
import Shimmer from 'sushiweb/Shimmer';
import { AddManualTagV1, TagsV1 } from '../../../commons';
import {
  ORDER_EVENTS,
  sendOrderApiEvents,
  sendOrderModalEvents,
} from '../../../../helpers/analytics/order.analytics';

const dashboard = window.dashboard.mode;
export default class OrderAdditionalInfoV1 extends Component {
  render() {
    const { orderBasicInfo } = this.props;
    return (
      <div className='additionalInfoContainerV1'>
        {!orderBasicInfo ? (
          <Shimmer height='6rem' width='100%' />
        ) : (
          <OrderAdditionalInfoComp {...this.props} />
        )}
      </div>
    );
  }
}

class OrderAdditionalInfoComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCommemntsPopup: false,
    };
  }

  componentDidMount = () => {
    this.getTags();
  };

  showCommemntsPopup = () => {
    const { orderId, userId } = this.props;
    sendOrderModalEvents(ORDER_EVENTS.COMMENTS_MODAL_OPEN, orderId, userId);
    this.setState({
      showCommemntsPopup: true,
    });
  };

  closeCommemntsPopup = () => {
    const { orderId, userId } = this.props;
    sendOrderModalEvents(ORDER_EVENTS.COMMENTS_MODAL_CLOSE, orderId, userId);
    this.setState({
      showCommemntsPopup: false,
    });
  };

  getTags = () => {
    const { orderId, getTags } = this.props;
    const querryParams = {};
    querryParams['order_id'] = orderId;
    getTags(querryParams);
  };

  selectedManualTag = (selectedManualTag, url) => {
    const { addManualTag, orderId, userId } = this.props;
    const data = {};
    data['order_id'] = orderId;
    data['tag_id'] = selectedManualTag;

    addManualTag(url, data, userId)
      .then((res) => {
        if (!res || (res && res.isError === true)) {
          sendOrderApiEvents(
            ORDER_EVENTS.ADD_MANUAL_TAG_FAILURE,
            orderId,
            userId,
          );
          toast.error(res.message ?? 'Oooopss! something went wrong!');
          return;
        }
        sendOrderApiEvents(
          ORDER_EVENTS.ADD_MANUAL_TAG_SUCCESS,
          orderId,
          userId,
          { tag: String(selectedManualTag) },
        );
        toast.success(res.message ?? 'Tag successfully added!');
        console.log('success');
        this.getTags();
      })
      .catch((error) => {
        sendOrderApiEvents(
          ORDER_EVENTS.ADD_MANUAL_TAG_FAILURE,
          orderId,
          userId,
        );

        toast.error('Oooopss! something went wrong!');
      });
  };

  render() {
    const {
      orderBasicInfo,
      orderId,
      userId,
      tags,
      showAddTagOnly = false,
    } = this.props;
    const { order } = orderBasicInfo;
    if (!order) return null;
    const { manual_tags } = order;

    if (showAddTagOnly && manual_tags)
      return (
        <AddManualTagV1
          manualTags={manual_tags}
          onSelectTag={this.selectedManualTag}
          addedTags={tags}
          orderId={orderId}
          userId={userId}
        />
      );

    if (!tags || (tags && tags.length === 0)) return null;

    return (
      <div
        className={`tw-w-full ${
          dashboard === 'smartplug' && tags ? '' : 'tw-pt-4'
        }`}
      >
        <div className='tw-flex tw-justify-between tw-w-full'>
          <div className='tw-bg-grey-200 tw-p-1 tw-rounded-lg tw-flex tw-items-center tw-gap-1'>
            <p className='tw-text-300 tw-font-medium tw-text-grey-800 tw-bg-white tw-px-4 tw-rounded-md tw-h-full'>
              Tags
            </p>

            <TagsV1 orderId={orderId} tags={tags} />
          </div>
        </div>
      </div>
    );
  }
}
